/**
 * Animates elements when they come into view.
 * @param {NodeListOf<Element>} elements - HTML elements to animate.
 */
export default function animateOnViewEnter(elements) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        if(!entry.target.hasAttribute('data-custom-delay')){
          entry.target.style.transitionDelay = (index + 1) / 10 + 's';
        }
        entry.target.classList.add('in-view');
        entry.target.classList.remove('to-animate');
        observer.unobserve(entry.target);
      }
    });
  }, {threshold: 0.1});

  elements.forEach(element => {
    observer.observe(element)
  });
}
